import styled from 'styled-components';
import { BasketOptionalPartsStyled } from '../BasketOptionalPartsStyled';
import { rem } from 'polished';

export const BasketOptionalPartsDetailsAC = styled(BasketOptionalPartsStyled)`
    .titleWrapper {
        color: ${({ theme }) => theme.colors.grey5};
    }

    .parts {
        &__title {
            font-size: ${({ theme }) => theme.fontSizes.h3};
            color: ${({ theme }) => theme.colors.grey5};
        }

        &__description {
            color: ${({ theme }) => theme.colors.grey5};
        }

        .part {
            color: ${({ theme }) => theme.colors.grey5};
            border-color: ${({ theme }) => theme.colors.blue2};
            border-radius: ${rem(12)};

            .checkbox-marker {
                border-radius: ${rem(4)};
            }

            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.white};
                border-color: ${({ theme }) => theme.colors.blue2};

                .checkbox-marker {
                    border-color: ${({ theme }) => theme.colors.blue2};
                }
            }

            &.selected {
                background: rgba(157, 199, 224, 0.2);
                border-color: ${({ theme }) => theme.colors.blue2};
            }

            &:not(.selected):hover,
            &:not(.selected):focus-visible {
                .checkbox-marker {
                    background: ${({ theme }) => theme.colors.white};
                }
            }

            &__name > span {
                font-size: ${rem(16)};
            }
        }

        .checkboxWrapper .checkbox-marker {
            border-color: ${({ theme }) => theme.colors.grey2};
        }
    }
`;
